import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "legend" }
const _hoisted_5 = { class: "legend" }
const _hoisted_6 = { class: "legend" }
const _hoisted_7 = { class: "legend" }

import { Authorization } from "@/services/authenticate";
import { showToastError } from "@/toastification";
import { reactive, onBeforeMount } from "vue";
import { useCalendarStore } from "@/stores/calendar";
import CalendarTable from "../../components/Calendar/CalendarTable.vue";
import { parseError } from "@/common/util";
import CalendarDay from "../../components/Calendar/CalendarDay.vue";
import MonthSelector from "@/components/util/MonthSelector.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarView',
  setup(__props) {

const calendarStore = useCalendarStore();

const state = reactive({
  date: { year: (new Date).getFullYear(), month: (new Date).getMonth()},
  dailyCommitment: 0,
});

onBeforeMount(async () => {
  await loadMonth();
});

async function onSelectedMonthChanged(newDate: any) {
  state.date = newDate;
  await loadMonth();
}

async function loadMonth() {
  try {
    await calendarStore.loadCalendarMonth(
      state.date.year,
      state.date.month + 1,
      Authorization.id
    );  
  }
  catch (e) {
    console.error(e);
    showToastError("Report was unable to generate: " + parseError(e));
  }
  finally {
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MonthSelector, { onMonthSelected: onSelectedMonthChanged }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(Authorization).accountName) + "'s Team Calendar", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createTextVNode(" Out of Office: ", -1)),
          _createVNode(CalendarDay, { dayData: { hours: null, isAbsent: false, outOfOffice: true, isPresent: false } })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createTextVNode(" Absent: ", -1)),
          _createVNode(CalendarDay, { dayData: { hours: null, isAbsent: true, outOfOffice: false, isPresent: false } })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createTextVNode(" Present: ", -1)),
          _createVNode(CalendarDay, { dayData: { hours: null, isAbsent: false, outOfOffice: false, isPresent: true } })
        ])
      ])
    ]),
    _createVNode(CalendarTable, {
      calendarData: _unref(calendarStore).getAll,
      date: state.date
    }, null, 8, ["calendarData", "date"])
  ]))
}
}

})